export const tipoUnidade = {
    PROPRIA: "Própria",
    TERCEIRA: "Terceira"
};